import { render, staticRenderFns } from "./category-breadcrumb-backlavel.vue?vue&type=template&id=7bc44554&"
import script from "./category-breadcrumb-backlavel.vue.ts?vue&type=script&lang=ts&"
export * from "./category-breadcrumb-backlavel.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports